var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn-toggle',[_c('v-btn',{attrs:{"disabled":!_vm.shop},on:{"click":_vm.dec}},[_c('v-icon',[_vm._v("mdi-minus")])],1),_c('v-btn',{attrs:{"color":"white"}},[_vm._v(" "+_vm._s(_vm.count)+" ")]),_c('v-btn',{attrs:{"disabled":!_vm.shop},on:{"click":_vm.inc}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }